import { Grid, TextField } from "@mui/material";
import { useOpen, useBlobUrl } from "../../../../../../../libs/hooks";
import { useWorkflowCheckpointStore } from "../../../../../store";
import { CameraComponentExporBananas } from "../../../../../../../libs/shared";
import { Button as ButtonAntd, Image, Input, message, Space } from "antd";
import notFound from "../../../../../assets/images/not-found.jpg";
import { CameraOutlined, SearchOutlined } from "@ant-design/icons";
import { workflowContainerFullForCPByContainer } from "../../../../../../../libs/apis";
import noImg from "../../../../../../../images/no-image.png";

export const Siglas = ({ block, width }: { block: boolean; width: string }) => {
  const container = useWorkflowCheckpointStore((state) => state.container);
  const siglasPhoto = useWorkflowCheckpointStore((state) => state.siglasPhoto);
  const setContainer = useWorkflowCheckpointStore(
    (state) => state.setContainer
  );
  const setSiglasPhoto = useWorkflowCheckpointStore(
    (state) => state.setSiglasPhoto
  );
  const setDataCF = useWorkflowCheckpointStore((state) => state.setDataCF);

  const siglasCheckPhoto = useWorkflowCheckpointStore(
    (state) => state.siglasCheckPhoto
  );
  const fotoUrl = useBlobUrl(siglasPhoto);

  const {
    open: openSiglas,
    handleClose: handleCloseSiglas,
    handleOpen: handleOpenSiglas,
  } = useOpen();

  const handleContainer = async () => {
    try {
      const { data: dataCF } = await workflowContainerFullForCPByContainer(
        container
      );
      if (!dataCF) return;
      console.log(dataCF)
      setDataCF(dataCF);
      message.success("Contenedor Encontrado!");
    } catch (err: any) {
      message.error(err.toString());
    }
  };

  if (width === "xs") {
    return (
      <Grid
        container
        justifyContent="space-around"
        spacing={2}
        sx={{ mt: 1, mb: 2, bgcolor: "white" }}
      >
        <Grid item xs={11}>
            <TextField
              fullWidth
              label="Contenedor"
              variant="outlined"
              size="medium"
              value={container || ""}
              onChange={(e) => {
                setContainer(e.target.value?.toUpperCase()?.trim());
              }}
              InputProps={{
                endAdornment: (
                  <ButtonAntd
                    shape="circle"
                    type="primary"
                    onClick={handleContainer}
                    icon={<SearchOutlined />}
                    size="large"
                  />
                ),
              }}
            />

        </Grid>
        <Grid
          item
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            alignContent: "center",
            alignItems: "center",
            justifyItems: "center",
            gap: 1,
          }}
        >
          <ButtonAntd
            onClick={handleOpenSiglas}
            type="primary"
            size="large"
            style={{ width: 130, fontWeight: "bold" }}
            icon={<CameraOutlined />}
          >
            Tomar Foto
          </ButtonAntd>
          <Image
            src={fotoUrl === "" ? noImg : fotoUrl}
            style={{
              width: 36,
              height: 36,
              borderRadius: 5,
              boxShadow: "0px 10px 15px 0px rgba(0,0,0,0.1)",
            }}
          />
          <CameraComponentExporBananas
            open={openSiglas!}
            handleClose={handleCloseSiglas!}
            setFoto={setSiglasPhoto!}
          />
        </Grid>
        <Grid
          item
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Image
            // src={foto === "" ? noImg : foto}
            src={siglasCheckPhoto === "" ? notFound : siglasCheckPhoto}
            style={{
              width: 45,
              height: 45,
              borderRadius: 5,
              boxShadow: "0px 10px 15px 0px rgba(0,0,0,0.1)",
              border: "1px solid darkgreen",
            }}
          />
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container spacing={1} sx={{ mt: 1, mb: 2, bgcolor: "white" }}>
      <Grid
        item
        xs={10}
        sm={11}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Grid
          container
          spacing={0.5}
          justifyContent="center"
          alignContent="center"
          alignItems="center"
        >
          <Grid
            item
            xs={10}
            sm={11}
            sx={{ display: "flex", justifyContent: "center", gap: 1 }}
          >
            <Input
              addonBefore={
                <Space.Compact
                  style={{ width: 80, position: "relative", left: -7 }}
                >
                  <ButtonAntd
                    style={{ fontSize: 8 }}
                    type="primary"
                    onClick={handleContainer}
                    size="small"
                  >
                    CONTENEDOR
                  </ButtonAntd>
                  <ButtonAntd
                    onClick={handleContainer}
                    icon={<SearchOutlined />}
                    size="small"
                  />
                </Space.Compact>
              }
              onPressEnter={() => {
                handleContainer();
              }}
              size="large"
              style={{ width: "85%" }}
              value={container || ""}
              onChange={(e) => {
                setContainer(e.target.value?.toUpperCase()?.trim());
              }}
            />
            <ButtonAntd
              onClick={handleOpenSiglas}
              type="primary"
              size="large"
              style={{ width: "13%" }}
              icon={<CameraOutlined />}
            />
          </Grid>

          <Grid item sx={{ display: "flex", justifyContent: "center" }}>
            <Image
              src={fotoUrl === "" ? noImg : fotoUrl}
              style={{
                width: 36,
                height: 36,
                borderRadius: 5,
                boxShadow: "0px 10px 15px 0px rgba(0,0,0,0.1)",
              }}
            />
            <CameraComponentExporBananas
              open={openSiglas!}
              handleClose={handleCloseSiglas!}
              setFoto={setSiglasPhoto!}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        xs={2}
        sm={1}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Image
          // src={foto === "" ? noImg : foto}
          src={siglasCheckPhoto === "" ? notFound : siglasCheckPhoto}
          style={{
            width: 36,
            height: 36,
            borderRadius: 5,
            boxShadow: "0px 10px 15px 0px rgba(0,0,0,0.1)",
          }}
        />
      </Grid>
    </Grid>
  );
};
